import cx from 'classnames'
import { useDevice } from 'device'
import React, { MouseEventHandler } from 'react'

import { InlineSvg, Text } from 'components/dataDisplay'

import TagView, { defaultColors, TagViewProps } from '../TagView/TagView'
import ButtonBase from '../../buttons/ButtonBase/ButtonBase'

import * as s from './TagButton.scss'


export type TagButtonProps = {
  className?: string
  color: typeof defaultColors[number]
  title: string
  active?: boolean
  iconSvg?: string
  onClick?: MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>
}

const inActiveColors: Record<TagButtonProps['color'], TagViewProps['color']> = {
  rocky: 'alien',
  matrix: 'drive',
  lebowski: 'snatch',
  fargo: 'indiana',
  snatch: 'snatch',
}

const TagButton: React.FC<TagButtonProps> = (props) => {
  const { className, title, active, color, iconSvg, ...rest } = props
  const { isDesktop } = useDevice()

  return (
    <TagView
      className={cx(s.tag, className, {
        [s.active]: active,
      })}
      color={active ? color : inActiveColors[color]}
      hover
      {...rest}
    >
      {
        !iconSvg && (
          <div className={cx(s.dot, 'radius-100 mr-4px')} />
        )
      }
      <Text size="c13" message={title} color="white" />
      {
        iconSvg && (
          <ButtonBase
            className={cx('pl-6px', {
              'color-white h-full flex items-center justify-end radius-16': isDesktop,
            })}
          >
            <InlineSvg
              src={iconSvg}
              width={12}
              height={12}
            />
          </ButtonBase>
        )
      }
    </TagView>
  )
}


export default TagButton
